import React from 'react'
import _ from 'lodash'

import {ChannelStore, ChannelService} from '../api/channel'

export class ChannelsStorage extends React.Component {
   static get propTypes() {
      return {
         nid:      React.PropTypes.string.isRequired,
         children: React.PropTypes.node.isRequired,
         onChange: React.PropTypes.func,
         filter:   React.PropTypes.func
      }
   }
   constructor(props) {
      super()
      this.state = {channels: ChannelStore.channels(props.nid)}
   }

   componentWillMount() {
      this._mounted = true

      ChannelService.list(this.props.nid)

      ChannelStore.addChangeListener(
         (this._listener = () => {
            if (this._mounted) {
               this.setState({channels: ChannelStore.channels(this.props.nid)})
            }
         })
      )
   }

   componentDidUpdate(prevProps, {channels}) {
      const {onChange} = this.props

      if (onChange && !_.isEqual(channels, this.state.channels)) {
         onChange(this.state.channels)
      }
   }

   componentWillReceiveProps({nid}) {
      if (nid && 0 === _.size(ChannelStore.channels(nid))) {
         ChannelService.list(nid)
      }

      if (this._mounted) {
         this.setState({channels: ChannelStore.channels(nid)})
      }
   }

   componentWillUnmount() {
      this._mounted = false
      ChannelStore.removeChangeListener(this._listener)
   }

   render() {
      let {channels} = this.state,
         {children, filter, ...props} = this.props,
         filteredChannels = channels

      if (filter) {
         filteredChannels = _.filter(channels, filter)
      }

      return React.cloneElement(
         children,
         _.assign({}, props, {
            channels:    filteredChannels,
            allChannels: channels
         })
      )
   }
}

export class ChannelStorage extends React.Component {
   static get propTypes() {
      return {
         nid:      React.PropTypes.string.isRequired,
         channel:  React.PropTypes.string,
         children: React.PropTypes.node.isRequired
      }
   }

   constructor(props) {
      super(props)
      this.state = {channel: ChannelStore.channel(props.nid, props.channel)}
   }

   componentWillMount() {
      let {nid, channel} = this.props

      this._mounted = true

      if (!nid || !channel) {
         return
      }

      // if (!ChannelStore.channel(nid, channel) && nid)
      ChannelService.fetch(nid, channel)

      ChannelStore.addChangeListener(
         (this._listener = () => {
            if (this._mounted) {
               this.setState({channel: ChannelStore.channel(this.props.nid, this.props.channel)})
            }
         })
      )
   }

   componentWillUnmount() {
      this._mounted = false
      ChannelStore.removeChangeListener(this._listener)
   }

   componentWillReceiveProps(next) {
      let channel = null

      if (next.nid !== this.props.nid) {
         channel = ChannelStore.channel(next.nid)

         if (!channel && next.nid) {
            ChannelService.fetch(next.nid)
         }

         this.setState({channel: channel})
      }
   }

   render() {
      let {channel} = this.state,
         {children, ...props} = this.props

      return React.cloneElement(children, _.assign({}, props, {channel}))
   }
}



// WEBPACK FOOTER //
// lib/storage/Channel.jsx